import { useContext } from "react";
import { FileTypes, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function ActualMeasureFiles() {

	const { order } = useContext(RetailOrderContext);

	const fileType = order.details.roTypeID === ROType.CabinetMeasureOrder ?
		FileTypes.CabinetMeasureWorksheet : FileTypes.PostTemplateDrawing;

	const caption =
		order.details.roTypeID === ROType.CabinetMeasureOrder ?
			"Upload Cabinet Measure Worksheet" : "Upload Post Template Drawing";

	return (
		<RetailOrderFiles fileTypes={[fileType]}
			defaultFileType={fileType}
			buttonCaption={caption}
			replaceFile={fileType === FileTypes.CabinetMeasureWorksheet}
		/>
	)
}